import { Injectable, Injector } from "@angular/core";
import * as _ from "lodash";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpHeaders,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { AuthService } from "../services/auth.service";
let headers = new HttpHeaders({
  "Content-Type": "application/vnd.api+json",
  Accept: "*/*",
});
@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private injector: Injector) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const auth = this.injector.get(AuthService);
    if (auth.getToken()) {
      headers = new HttpHeaders({
        Authorization: auth.getToken(),
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        Accept: "application/json, text/plain, */*",
      });

      if (request.headers.has("searchType")) {
        headers = new HttpHeaders({
          Authorization: auth.getToken(),
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          Accept: "application/json, text/plain, */*",
          searchType: request.headers.get("searchType"),
        });
      } 
      if (request.url.indexOf("transit-hub") > 0) {
        headers = new HttpHeaders({
          Authorization: auth.getTHJWTToken(),
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          Accept: "application/json, text/plain, */*",
        });
      }
    }

    const clonedRequest = request.clone({
      headers: headers,
      url: request.url,
    });

    return next.handle(clonedRequest);
  }
}
